import React from 'react';
import { PropTypes } from 'prop-types';
import { useSelector } from 'react-redux';

const MultiSelectFilter = ({ column: { filterValue, setFilter, preFilteredRows, id, filterType, options } }) => {
  const [inputValue, setInputValue] = React.useState([]);
  const [showFilter, setShowFilter] = React.useState(false);
  const formtypes = useSelector(state => state.auth.settings.formtypes);
  const node = React.useRef();

  const handleClickOutside = (e) => {
    if (node === null || node.current === null) {
      return;
    }
    if (node.current.contains(e.target)) {
      // inside click
      return;
    }
    setShowFilter(false);
  };
  const baseOptions = React.useMemo(() => {
    let opts = new Set();
    switch (id) {
      case 'cicDataPoints':
        opts = new Set();
        opts.add({ title: 'Name', value: 'name' });
        opts.add({ title: 'Permanent Address Country', value: 'permanentaddress' });
        opts.add({ title: 'Mailing Address Country', value: 'mailingaddress' });
        opts.add({ title: 'US Tax Residency', value: 'ustaxresidency' });
        opts.add({ title: 'US TIN', value: 'ustin' });
        opts.add({ title: 'GIIN', value: 'giin' });
        opts.add({ title: 'Country Of Birth', value: 'countryofbirth' });
        opts.add({ title: 'Phone Number', value: 'phonenumber' });
        opts.add({ title: 'Entity Type', value: 'entitytype' });
        opts.add({ title: 'Treaty Country', value: 'treatycountry' });
        opts.add({ title: 'Treaty Eligibility', value: 'treatyeligibility' });
        opts.add({ title: 'Residence Country Differs From Treaty Country', value: 'residencecountrydiffersfromtreaty' });
        opts.add({ title: 'Tax Country Differs From Treaty Country', value: 'taxcountrydiffersfromtreaty' });
        opts.add({ title: 'GIIN Removed from IRS GIIN list', value: 'giinremoved' });
        opts.add({ title: 'International Organisation Removed From List', value: 'internationalorganisationremoved' });
        break;
      case 'closureReasonDesc':
        opts = new Set();
        opts.add({ title: 'Processed', value: 'processed' });
        opts.add({ title: 'Expired', value: 'expired' });
        opts.add({ title: 'N/A', value: 'unknown' });
        break;
      case 'formType':
      case 'formTypeDescription':
        opts = new Set();
        if (formtypes.some(ft => ft.key === 'w8ben_2014')) opts.add({ title: 'W-8BEN Jul-2014', value: 'w8ben_2014' });
        if (formtypes.some(ft => ft.key === 'w8ben')) opts.add({ title: 'W-8BEN Jul-2017', value: 'w8ben' });
        if (formtypes.some(ft => ft.key === 'w8ben_2021')) opts.add({ title: 'W-8BEN Oct-2021', value: 'w8ben_2021' });
        if (formtypes.some(ft => ft.key === 'w8bene')) opts.add({ title: 'W-8BEN-E Apr-2016', value: 'w8bene' });
        if (formtypes.some(ft => ft.key === 'w8bene_2017')) opts.add({ title: 'W-8BEN-E Jul-2017', value: 'w8bene_2017' });
        if (formtypes.some(ft => ft.key === 'w8bene_2021')) opts.add({ title: 'W-8BEN-E Oct-2021', value: 'w8bene_2021' });
        if (formtypes.some(ft => ft.key === 'w8imy')) opts.add({ title: 'W-8IMY Sep-2016', value: 'w8imy' });
        if (formtypes.some(ft => ft.key === 'w8imy_2017')) opts.add({ title: 'W-8IMY Jun-2017', value: 'w8imy_2017' });
        if (formtypes.some(ft => ft.key === 'w8imy_2021')) opts.add({ title: 'W-8IMY Oct-2021', value: 'w8imy_2021' });
        if (formtypes.some(ft => ft.key === 'w8exp_2016')) opts.add({ title: 'W-8EXP Sep-2016', value: 'w8exp_2016' });
        if (formtypes.some(ft => ft.key === 'w8exp')) opts.add({ title: 'W-8EXP Jul-2017', value: 'w8exp' });
        if (formtypes.some(ft => ft.key === 'w8exp_2023')) opts.add({ title: 'W-8EXP Oct-2023', value: 'w8exp_2023' });
        if (formtypes.some(ft => ft.key === 'w8eci_2014')) opts.add({ title: 'W-8ECI Feb-2014', value: 'w8eci_2014' });
        if (formtypes.some(ft => ft.key === 'w8eci')) opts.add({ title: 'W-8ECI Jul-2017', value: 'w8eci' });
        if (formtypes.some(ft => ft.key === 'w8eci_2021')) opts.add({ title: 'W-8ECI Oct-2021', value: 'w8eci_2021' });
        if (formtypes.some(ft => ft.key === 'w9')) opts.add({ title: 'W-9 Dec-2014', value: 'w9' });
        if (formtypes.some(ft => ft.key === 'w9_2017')) opts.add({ title: 'W-9 Nov-2017', value: 'w9_2017' });
        if (formtypes.some(ft => ft.key === 'w9_2018')) opts.add({ title: 'W-9 Oct-2018', value: 'w9_2018' });
        if (formtypes.some(ft => ft.key === 'w9_2024')) opts.add({ title: 'W-9 Mar-2024', value: 'w9_2024' });
        if (formtypes.some(ft => ft.key === 'crscp')) opts.add({ title: 'CRSCP 2017', value: 'crscp' });
        if (formtypes.some(ft => ft.key === 'crse')) opts.add({ title: 'CRSE 2017', value: 'crse' });
        if (formtypes.some(ft => ft.key === 'crsi')) opts.add({ title: 'CRSI 2017', value: 'crsi' });
        if (formtypes.some(ft => ft.key === 'crsi_2024')) opts.add({ title: 'CRSI 2024', value: 'crsi_2024' });
        if (formtypes.some(ft => ft.key === 'dt_crscp')) opts.add({ title: 'Deloitte CRS-CP', value: 'dt_crscp' });
        if (formtypes.some(ft => ft.key === 'dt_crsi')) opts.add({ title: 'Deloitte CRS-I', value: 'dt_crsi' });
        if (formtypes.some(ft => ft.key === 'dt_crse')) opts.add({ title: 'Deloitte CRS-E', value: 'dt_crse' });
        if (formtypes.some(ft => ft.key === 'ucrscp_2025')) opts.add({ title: 'Universal CRSCP 2025', value: 'ucrscp_2025' });
        if (formtypes.some(ft => ft.key === 'ucrse_2025')) opts.add({ title: 'Universal CRSE 2025', value: 'ucrse_2025' });
        if (formtypes.some(ft => ft.key === 'ucrsi_2025')) opts.add({ title: 'Universal CRSI 2025', value: 'ucrsi_2025' });
        if (formtypes.some(ft => ft.key === 'fatca_crsi_2022')) opts.add({ title: 'FATCA/CRS-I Jun-2022', value: 'fatca_crsi_2022' });
        if (formtypes.some(ft => ft.key === 'fatca_crsi_2023')) opts.add({ title: 'FATCA/CRS-I Apr-2023', value: 'fatca_crsi_2023' });
        if (formtypes.some(ft => ft.key === 'fatca_crse_2022')) opts.add({ title: 'FATCA/CRS-E Jul-2022', value: 'fatca_crse_2022' });
        if (formtypes.some(ft => ft.key === 'fatca_crse_2023')) opts.add({ title: 'FATCA/CRS-E Apr-2023', value: 'fatca_crse_2023' });
        if (formtypes.some(ft => ft.key === 'rc518')) opts.add({ title: 'RC518 2023', value: 'rc518' });
        if (formtypes.some(ft => ft.key === 'rc518_2024')) opts.add({ title: 'RC518 2024', value: 'rc518_2024' });
        if (formtypes.some(ft => ft.key === 'rc518_2025')) opts.add({ title: 'RC518 2025', value: 'rc518_2025' });
        if (formtypes.some(ft => ft.key === 'rc519')) opts.add({ title: 'RC519 2023', value: 'rc519' });
        if (formtypes.some(ft => ft.key === 'rc519_2024')) opts.add({ title: 'RC519 2024', value: 'rc519_2024' });
        if (formtypes.some(ft => ft.key === 'rc519_2025')) opts.add({ title: 'RC519 2025', value: 'rc519_2025' });
        if (formtypes.some(ft => ft.key === 'ucarfcp_2026')) opts.add({ title: 'Universal CARF-CP 2026', value: 'ucarfcp_2026' });
        if (formtypes.some(ft => ft.key === 'ucarfi_2026')) opts.add({ title: 'Universal CARF-I 2026', value: 'ucarfi_2026' });
        if (formtypes.some(ft => ft.key === 'ucarfe_2026')) opts.add({ title: 'Universal CARF-E 2026', value: 'ucarfe_2026' });
        break;
      case 'imyFormType':
        opts = new Set();
        if (formtypes.some(ft => ft.key === 'w8imy')) opts.add({ title: 'W-8IMY Sep-2016', value: 'w8imy' });
        if (formtypes.some(ft => ft.key === 'w8imy_2017')) opts.add({ title: 'W-8IMY Jun-2017', value: 'w8imy_2017' });
        if (formtypes.some(ft => ft.key === 'w8imy_2021')) opts.add({ title: 'W-8IMY Oct-2021', value: 'w8imy_2021' });
        break;
      case 'formSourceDescription':
        opts = new Set();
        opts.add({ title: 'Scanned Form Upload', value: 'manualupload' });
        opts.add({ title: 'Digital Entry', value: 'digitalentry' });
        opts.add({ title: 'Online', value: 'online' });
        opts.add({ title: 'Batch', value: 'batch' });
        break;
      case 'isValid':
        opts = new Set();
        opts.add('true');
        opts.add('false');
        break;
      case 'validityDescription':
        opts = new Set();
        opts.add({ title: 'Valid (Not Expired)', value: 'validactive' });
        opts.add({ title: 'Valid (Under Review)', value: 'validunderreview' });
        opts.add({ title: 'Invalid', value: 'invalid' });
        opts.add({ title: 'Expired', value: 'expired' });
        opts.add({ title: 'Not Validated', value: 'notvalidated' });
        break;
      case 'workflowStageDescription':
        opts = new Set();
        opts.add({ title: 'Pending Initial Review', value: 'pendingreview' });
        opts.add({ title: 'Under Initial Review', value: 'underinitialreview' });
        opts.add({ title: 'Pending Secondary Review', value: 'pendingsecondaryreview' });
        opts.add({ title: 'Under Secondary Review', value: 'undersecondaryreview' });
        opts.add({ title: 'Pending Expert Review', value: 'pendingexpertreview' });
        opts.add({ title: 'Under Expert Review', value: 'underexpertreview' });
        opts.add({ title: 'Complete', value: 'complete' });
        opts.add({ title: 'Draft', value: 'draft' });
        break;
      case 'chapter3Status':
        opts = new Set();
        opts.add({ title: 'Non Qualified Intermediary', value: 'nonqualifiedintermediary' });
        opts.add({ title: 'Nonwithholding Foreign Grantor Trust', value: 'nonwithholdingforeigngrantortrust' });
        opts.add({ title: 'Nonwithholding Foreign Partnership', value: 'nonwithholdingforeignpartnership' });
        opts.add({ title: 'Nonwithholding Foreign Simple Trust', value: 'nonwithholdingforeignsimpletrust' });
        opts.add({ title: 'Qualified Intermediary', value: 'qualifiedintermediary' });
        opts.add({ title: 'Territory Financial Institution', value: 'territoryfinancialinstitution' });
        opts.add({ title: 'US Branch', value: 'usbranch' });
        opts.add({ title: 'Withholding Foreign Partnership', value: 'withholdingforeignpartnership' });
        opts.add({ title: 'Withholding Foreign Trust', value: 'withholdingforeigntrust' });
        break;
      case 'expectedWithholdingStatementType':
        opts = new Set();
        opts.add({ title: 'Alternative', value: 'Alternative' });
        opts.add({ title: 'Detailed', value: 'Detailed' });
        opts.add({ title: 'Not Applicable', value: 'NotApplicable' });
        opts.add({ title: 'No WHS', value: 'NoWhs' });
        opts.add({ title: 'Pooled', value: 'Pooled' });
        opts.add({ title: 'Simple', value: 'Simple' });
        break;
      case 'documentUploadStatus':
        opts = new Set();
        opts.add({ title: 'Queued', value: 'Queued' });
        opts.add({ title: 'Dispatched', value: 'Dispatched' });
        opts.add({ title: 'Processing', value: 'Processing' });
        opts.add({ title: 'Processed', value: 'Processed' });
        opts.add({ title: 'Processed Some', value: 'ProcessedSome' });
        opts.add({ title: 'No Forms Found', value: 'NoFormsFound' });
        opts.add({ title: 'Failed Processing', value: 'FailedProcessing' });
        opts.add({ title: 'File Unreadable', value: 'FileUnreadable' });
        opts.add({ title: 'File Not Found', value: 'FileNotFound' });
        opts.add({ title: 'Internal Error', value: 'InternalError' });
        opts.add({ title: 'Failed Pickup', value: 'FailedPickup' });
        opts.add({ title: 'Possible Duplicate', value: 'PossibleDuplicate' });
        opts.add({ title: 'Bad Zip File', value: 'BadZipFile' });
        opts.add({ title: 'Bad Cover Sheet', value: 'BadCoverSheet' });
        opts.add({ title: 'Failed to Upload Forms', value: 'FailedUploadForms' });
        break;
      default:
        break;
    }
    return [...opts.values()];
  }, [id]);

  if (!options || options.length === 0) {
    options = baseOptions;
  }

  if (!filterType) {
    filterType = 'multiselect';
  }

  const keyHit = (e) => {
    if (e.keyCode === 13) {
      setShowFilter(false);
      setFilter({
        filter: inputValue,
        filterType: `${ filterType }`
      });
    }
  };

  const filterInput = React.createRef();

  const clear = () => {
    for (let i = 0, l = filterInput.current.options.length; i < l; i += 1) {
      filterInput.current.options[i].selected = false;
    }
    setShowFilter(false);
    setInputValue([]);
    setFilter({
      filter: [],
      filterType: 'multiselect'
    });
  };

  React.useEffect(() => {
    setInputValue(filterValue != null && filterValue.filter.length > 0 ? filterValue.filter : '');

    if (filterValue?.filter && filterValue.filter.length > 0) {
      for (let i = 0, l = filterValue.filter.length; i < l; i += 1) {
        for (let j = 0, k = filterInput.current.options.length; j < k; j += 1) {
          if (filterInput.current.options[j].value === filterValue.filter[i]) {
            filterInput.current.options[j].selected = true;
          }
        }
      }
    } else {
      for (let i = 0, l = filterInput.current.options.length; i < l; i += 1) {
        filterInput.current.options[i].selected = false;
      }
    }
  }, [filterValue]);

  React.useEffect(() => {
    if (showFilter) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showFilter]);

  return (
    <div ref={ node } className={ `clickover clickover-bottom filter ${ showFilter ? 'active' : '' }` }>
      <button type="button" onClick={ () => setShowFilter(!showFilter) } className={ `btn btn-link filter-menu ${ filterValue != null && filterValue.filter.length > 0 ? 'filter-active' : '' }` }>☰</button>
      <div className="clickover-container">
        <div className="card card-primary">
          <div className="card-body">
            <div className="columns">
              <div className="col-12">
                <select
                  ref={ filterInput }
                  multiple
                  onChange={ (e) => {
                    const ops = e.target.options;
                    const value = [];
                    for (let i = 0, l = ops.length; i < l; i += 1) {
                      if (ops[i].selected) {
                        value.push(ops[i].value);
                      }
                    }
                    setInputValue(value);
                  } }
                  onKeyUp={ (e) => { keyHit(e); } }
                >
                  { options.map((option, i) => (
                    <option key={ (option && option.value) || option } value={ (option && option.value) || option }>
                      { (option && option.title) || option }
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-6">
                <button
                  id="search-btn"
                  type="button"
                  className="btn btn-primary btn-sm"
                  onClick={ () => {
                    setShowFilter(false);
                    setFilter({ filter: inputValue, filterType: 'multiselect' });
                  } }
                ><span className="icon icon-search" /> Filter</button>
              </div>
              <div className="col-6">
                <button
                  id="search-btn"
                  type="button"
                  className="btn btn-primary btn-sm"
                  disabled={ inputValue.length === 0 }
                  onClick={ () => {
                    clear();
                  } }
                ><span className="icon icon-cross" /> Clear</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

MultiSelectFilter.propTypes = {
  column: PropTypes.shape().isRequired,
};

MultiSelectFilter.defaultProps = {
};

export default MultiSelectFilter;
